module.exports = __webpack_public_path__ + "static/img/1.32887bf2.png";